/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import {ButtonOutline, ButtonPrimary} from '../../../../components/buttons';
import DialogContainer from '../../../../components/DialogContainer/styles.js';
import DialogClose from '../../../../components/DialogClose/styles.js';
import {DialogBody, DialogText} from '../../dashboard/styles.js';
import Loading from '../../../../components/shared/Utils/Loading';
import DialogActions from '../../../../components/DialogActions/styles';
import DialogAction from '../../../../components/DialogAction/styles';
import DialogTitle from '../../../../components/DialogTitle/styles';
import DialogSubTitle from '../../../../components/DialogSubTitle/styles';

function ConfirmPriceAdjustModal({
  isLoading,
  isOpen,
  message,
  subtitle,
  onCancel,
  onOk
}) {
  const onOkClick = () => {
    onOk();
  };

  const onCancelClick = () => {
    onCancel();
  };

  return (
    <Dialog open={isOpen} scroll='body' onClose={onCancelClick}>
      <DialogContainer className='DialogSm ConfirmModal'>
        <DialogClose onClick={onCancelClick} />
        <DialogTitle>{message}</DialogTitle>
        <DialogText className='marginT20'>{subtitle}</DialogText>
        <DialogBody className='ConfirmModal-BtnPanel'>
          {isLoading && <Loading />}
          {!isLoading && (
            <DialogActions className='marginTopNull DialogActionsMin DialogActionsNoWrap'>
              <DialogAction className='w50'>
                <ButtonOutline type='button' onClick={onCancelClick}>
                  Cancel
                </ButtonOutline>
              </DialogAction>
              <DialogAction className='w50'>
                <ButtonPrimary type='button' onClick={onOkClick}>
                  <span>Confirm</span>
                </ButtonPrimary>
              </DialogAction>
            </DialogActions>
          )}
        </DialogBody>
      </DialogContainer>
    </Dialog>
  );
}

ConfirmPriceAdjustModal.propTypes = {
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  message: PropTypes.string,
  subtitle: PropTypes.string,
  onCancel: PropTypes.func,
  onOk: PropTypes.func
};

ConfirmPriceAdjustModal.defaultProps = {
  isLoading: false,
  isOpen: false,
  message: '',
  subtitle: '',
  onCancel: () => {},
  onOk: () => {}
};

export default ConfirmPriceAdjustModal;
